module.exports = __webpack_public_path__ + "html/explainer_b9270ebd62e22f6af81d86fc697c6521.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/explainer.html
// module id = v09R
// module chunks = 118